import { QueryKey, useQuery, UseQueryOptions } from 'react-query';

import { getActivityById } from '@zero5/activity-api';

import { mapFullActivityResponse } from '@/api/mappings/activity';


type Response = ReturnType<typeof mapFullActivityResponse>;

export const queryKey: QueryKey = 'activitiesQuery';

type Key = [typeof queryKey, string];

const useGetFullActivityInfo = (
  activityId: string,
  options?: UseQueryOptions<Response, unknown, Response, Key>,
) => {
  return useQuery<Response, unknown, Response, Key>(
    [queryKey, activityId],
    async () => {
      const response = await getActivityById({ activityId });
      return mapFullActivityResponse(response);
    },
    {
      refetchOnWindowFocus: false,
      ...options,
    },
  );
};

export default useGetFullActivityInfo;
